/* @flow weak */
import React from 'react';
import Button from 'components/Button.jsx';

const BirthdateModalSectionMixin = {
  getInitialState() {
    return {
      submitted: false,
    };
  },

  submit() {
    this.setState({ submitted: true });
    this.onSubmit();
  },

  renderHeader(title, subtext) {
    return (
      <div className="BirthdateModal-boxHeader">
        <h2 className="BirthdateModal-boxTitle">{title}</h2>
        <div className="BirthdateModal-boxSubtext">
          {subtext}
        </div>
      </div>
    );
  },

  renderSubmitButton() {
    return (
      <Button
        level="primary"
        onClick={this.submit}
        disabled={this.state.submitted || this.buttonDisabled()}>
        Submit
      </Button>
    );
  },

  render() {
    return (
      <div>
        {this.renderHeader(this.title(), this.getSubtext ? this.getSubtext() : null)}
        <div>
          <div className="BirthdateModal-boxArea">
            {this.renderCollector()}
          </div>
          <div className="BirthdateModal-boxArea">
            {this.renderSubmitButton()}
          </div>
        </div>
      </div>
    );
  },
};

export default BirthdateModalSectionMixin;



// WEBPACK FOOTER //
// ./src/chat/components/mixins/BirthdateModalSectionMixin.jsx